import classnames from 'classnames';

import { Text } from '@ekhodealer/ekho-common/rev';

import type { TextProps } from '@ekhodealer/ekho-common/rev';

import { PLACEHOLDER } from '@common/lib/strings';

import './TextCell.scss';

interface TextCellProps {
	value?: string;
	weight?: TextProps['weight'];
	noWrap?: boolean;
	monospace?: boolean;
}

export const TextCell = ({
	value,
	weight = 'regular',
	noWrap = true,
	monospace = false,
}: TextCellProps) => {
	const textStyle = monospace ? { fontFamily: 'monospace' } : undefined;
	return (
		<div
			className={classnames('text-cell', { 'text-cell__no-wrap': noWrap })}
			style={textStyle}>
			<Text size='bodySmall' weight={weight}>
				{value || PLACEHOLDER}
			</Text>
		</div>
	);
};
